var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UtilityPageContainer',{attrs:{"wIconSrc":require('@/assets/icons/pages/maintenance.svg'),"title":_vm.$t('msg-title'),"text":_vm.$t('msg-text')}})}
var staticRenderFns = []

export { render, staticRenderFns }